// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://unxpriutkasdnfekqjtw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVueHByaXV0a2FzZG5mZWtxanR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk5MTM4NTksImV4cCI6MjA3NTQ4OTg1OX0.yIxFCUFhJ-Y-PNi1FsCIFoeB_Ong6MVa4AUj-aSesBw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
